import "./ScheduleInfo.scss";
import {
  CalendarBlankIcon,
  InfoSmallIcon,
  MapPinIcon,
  OptimizelyEditProperty,
} from "/App.Components";
import { ScheduleInfoProps } from "/Models/Generated/ScheduleInfoProps";

const ScheduleInfo = ({
  timeLabel,
  time,
  timePropertyName,
  locationLabel,
  location,
  locationPropertyName,
}: ScheduleInfoProps) => (
  <div className="schedule-info-norad">
    {(time || timePropertyName) && (
      <OptimizelyEditProperty propertyName={timePropertyName}>
        <InfoSmallIcon
          boldText={timeLabel}
          text={time ?? ""}
          icon={CalendarBlankIcon}
        />
      </OptimizelyEditProperty>
    )}
    {(location || locationPropertyName) && (
      <OptimizelyEditProperty propertyName={locationPropertyName}>
        <InfoSmallIcon
          boldText={locationLabel}
          text={location ?? ""}
          icon={MapPinIcon}
        />
      </OptimizelyEditProperty>
    )}
  </div>
);

export default ScheduleInfo;
